import { updateAccountUI } from './account.js';
import { CLOUD, cloudOn, cloudPersistLS, friendlyErr, loggedIn, sbUrl } from './api.js';
import { cloudSignIn, cloudSignOut, cloudSignUp, drawPwMeter, mfaChallenge, mfaRequired, mfaVerify, pwOK, resendOtp, sendEmailCode, sendRecovery, updatePassword, verifyEmailCode, verifyOtp } from './auth.js';
import { cloudSyncStart } from './sync.js';
import { t } from '../i18n/index.js';
import { runDeepLink } from '../notify/deeplink.js';
import { syncPush } from '../notify/push.js';
import { maybeWelcome } from '../welcome.js';
import { afterTeamLoad, joinNotice, pendingJoin, runJoin } from '../team/team.js';
import { bootDone } from './boot.js';
import { S, persist } from '../state.js';
import { updateLangButtons } from '../theme.js';
import { $, IC, RT, esc, render, toast } from '../ui.js';
import { LEGAL, ext } from '../legal.js';
import { markFreshLogin, maybeSecureSheet, reportDevice } from './devices.js';

/* Sign-in = an open exercise book: the cover with its name label on the left,
   a ruled page with the form on the right. The label's name line fills in as you type. */
let LAST={screen:'login',arg:null,opts:{}};
export function closeAuth(){$('#authroot').innerHTML=''}
export const GLOGO='<svg viewBox="0 0 48 48" style="width:18px;height:18px" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.1H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.1 6.1 29.3 4 24 4 13 4 4 13 4 24s9 20 20 20 20-9 20-20c0-1.3-.1-2.6-.4-3.9z"/><path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.9 1.2 8 3l5.7-5.7C34.1 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.1H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C41.4 35.4 44 30.2 44 24c0-1.3-.1-2.6-.4-3.9z"/></svg>';
const FEATHER='<svg viewBox="96 96 320 340" aria-hidden="true"><path d="M352 112c-72 8-136 56-168 120-20.8 41.6-28.8 88-31.2 132.8l-4.8 39.2c-.8 7.2 7.2 12.8 13.6 8.8l33.6-20.8C240 368 284 344 316 308c44-48 56-128 36-196z" fill="#F7F6F1"/><path d="M160 392 336 160" stroke="#E0342B" stroke-width="22" stroke-linecap="round"/></svg>';
const ALERT='<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.01"/></svg>';

export function authShell(inner){
  const L=S.settings.lang;
  return `<div class="authback"><div class="authcard">
    <a class="authbrand" href="https://plumeplaner.de" aria-label="Plume"><span class="authlogo" aria-hidden="true">${FEATHER}</span><span class="authword">plume<i>.</i></span></a>
    <div class="authbody">${inner}</div>
    <footer class="authfoot">
      <div class="authlang" role="group" aria-label="${t('c.language')}">${['de','en','fr'].map(l=>`<button type="button" data-lang="${l}" class="${L===l?'on':''}" lang="${l}" aria-pressed="${L===l}">${l.toUpperCase()}</button>`).join('')}</div>
      <nav class="authlinks"><a href="${LEGAL.privacy}" target="_blank" rel="noopener">${t('lg.privacy')}</a><a href="${LEGAL.imprint}" target="_blank" rel="noopener">${t('lg.imprint')}</a></nav>
    </footer></div></div>`;
}
function mount(screen,arg,opts,html){
  LAST={screen,arg,opts:opts||{}};
  const root=$('#authroot');root.innerHTML=authShell(html);
  root.querySelectorAll('[data-lang]').forEach(b=>b.onclick=()=>{
    const em=$('#au-em');const keep=em?em.value:(LAST.opts.email||'');
    S.settings.lang=b.dataset.lang;persist();updateLangButtons();try{render()}catch(e){}
    openAuth(LAST.screen,LAST.arg,{...LAST.opts,email:keep});
  });
  const em=$('#au-em'),nm=$('#lb-name');
  if(em&&nm){const fill=()=>{nm.textContent=em.value.trim()};em.addEventListener('input',fill);fill()}
}
export function authErr(msg,fieldId){
  const e=$('#au-err');if(!e)return;
  e.hidden=false;e.innerHTML=ALERT+'<span>'+esc(friendlyErr(msg))+'</span>';
  document.querySelectorAll('#authroot [aria-invalid]').forEach(x=>x.removeAttribute('aria-invalid'));
  const f=fieldId&&$('#'+fieldId);if(f){f.setAttribute('aria-invalid','true');f.focus()}
}
function clearErr(){const e=$('#au-err');if(e)e.hidden=true;document.querySelectorAll('#authroot [aria-invalid]').forEach(x=>x.removeAttribute('aria-invalid'))}
export function authBusy(on){
  const b=$('#au-go');if(!b)return;
  if(on){b.dataset.label=b.textContent;b.classList.add('busy');b.disabled=true;b.textContent=t('lg.busy')}
  else{b.classList.remove('busy');b.disabled=false;if(b.dataset.label)b.textContent=b.dataset.label}
  document.querySelectorAll('#authroot input').forEach(i=>{i.readOnly=on||i.dataset.locked==='1'});
}
export function afterLogin(){
  document.body.classList.add('booting');
  closeAuth();
  try{if(/^\/(login|signup)\/?$/.test(location.pathname)||location.search.includes('signup'))history.replaceState(null,'','/'+location.hash)}catch(e){}
  try{localStorage.removeItem('plume.mode')}catch(e){}
  toast(t('cloud.in',{e:CLOUD.auth.email||''}));
  updateAccountUI();
  document.body.classList.add('booting');
  markFreshLogin();
  (async()=>{if(pendingJoin()&&await runJoin())return;await cloudSyncStart();maybeWelcome();bootDone();afterTeamLoad();syncPush();runDeepLink();reportDevice();maybeSecureSheet()})().catch(()=>bootDone());
  if(RT.v==='settings')render();
}
export function otpBox(id){return '<div class="otpwrap"><input class="otpinput" id="'+id+'" inputmode="numeric" autocomplete="one-time-code" maxlength="6" placeholder="000000" aria-label="'+t('auth.otpTitle')+'"></div>'}
export function googleAuthUrl(){
  return sbUrl('/auth/v1/authorize?provider=google&apikey='+encodeURIComponent(CLOUD.cfg.key)+'&redirect_to='+encodeURIComponent(location.origin+location.pathname));
}
const head=(title,sub)=>'<h1>'+esc(title)+'</h1>'+(sub?'<p class="authsub">'+sub+'</p>':'');
const errBox='<div class="autherr" id="au-err" role="alert" hidden></div>';
const submit=(fn)=>{const f=$('#au-form');if(f)f.onsubmit=e=>{e.preventDefault();fn()}};
const codeInput=(go)=>{const inp=$('#au-otp');inp.focus();inp.oninput=()=>{inp.value=inp.value.replace(/\D/g,'').slice(0,6);clearErr();if(inp.value.length===6)go()};return inp};

export function openAuth(screen,arg,opts){
  opts=opts||{};
  /* ---- one-time project setup (only when no Supabase is baked into the build) ---- */
  if(screen==='setup'){
    mount(screen,arg,opts,head(t('cloud.title'),esc(t('cloud.setupHint')))+
      '<form id="au-form" novalidate><div class="field"><label for="au-url">'+t('cloud.url')+'</label><input class="input" id="au-url" placeholder="https://xxxx.supabase.co" value="'+esc(CLOUD.cfg&&CLOUD.cfg.url||'')+'"></div>'+
      '<div class="field"><label for="au-key">'+t('cloud.key')+'</label><input class="input" id="au-key" placeholder="eyJhbGciOi…" value="'+esc(CLOUD.cfg&&CLOUD.cfg.key||'')+'"></div>'+
      errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('cloud.continue')+'</button></form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-off">'+t('cloud.offline')+'</button></p>');
    submit(()=>{
      const url=$('#au-url').value.trim(),key=$('#au-key').value.trim();
      if(!/^https:\/\/.+/.test(url)||key.length<20){authErr(t('cloud.badcfg'),'au-url');return}
      CLOUD.cfg={url,key};cloudPersistLS();openAuth('login');
    });
    $('#au-off').onclick=goOffline;
    return;
  }
  /* ---- email code after sign-up ---- */
  if(screen==='otp'){
    const email=arg;
    mount(screen,arg,opts,head(t('auth.otpTitle'),esc(t('auth.otpSent',{e:email})))+
      '<form id="au-form" novalidate>'+otpBox('au-otp')+errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('auth.otpVerify')+'</button></form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-resend">'+t('auth.otpResend')+'</button></p>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-back">'+t('auth.back')+'</button></p>');
    const go=async()=>{
      const code=$('#au-otp').value.trim();
      if(code.length!==6){authErr(t('auth.eCode'),'au-otp');return}
      authBusy(true);
      try{await verifyOtp(email,code,'signup');if(await mfaRequired())openAuth('mfa');else afterLogin()}
      catch(e){authBusy(false);authErr(e.message,'au-otp')}
    };
    codeInput(go);submit(go);
    $('#au-resend').onclick=async()=>{try{await resendOtp(email,'signup');toast(t('auth.otpResent'))}catch(e){authErr(e.message)}};
    $('#au-back').onclick=()=>openAuth('login',false,{email});
    return;
  }
  /* ---- second factor ---- */
  if(screen==='mfa'){
    mount(screen,arg,opts,head(t('auth.mfaTitle'),esc(t('auth.mfaAsk')))+
      '<form id="au-form" novalidate>'+otpBox('au-otp')+errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('auth.mfaVerify')+'</button></form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-back">'+t('cloud.out')+'</button></p>');
    const go=async()=>{
      const code=$('#au-otp').value.trim();
      if(code.length!==6){authErr(t('auth.eCode'),'au-otp');return}
      authBusy(true);
      try{const ch=await mfaChallenge(CLOUD.mfa.id);await mfaVerify(CLOUD.mfa.id,ch.id,code);CLOUD.mfa=null;afterLogin()}
      catch(e){authBusy(false);authErr(e.message,'au-otp')}
    };
    codeInput(go);submit(go);
    $('#au-back').onclick=()=>{cloudSignOut(true);openAuth('login')};
    return;
  }
  /* ---- forgot password ---- */
  if(screen==='forgot'){
    mount(screen,arg,opts,head(t('auth.resetTitle'),esc(t('auth.resetHint')))+
      '<form id="au-form" novalidate><div class="field"><label for="au-em">'+t('cloud.email')+'</label><input class="input" type="email" id="au-em" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" value="'+esc(arg||opts.email||'')+'"></div>'+
      errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('auth.resetSend')+'</button></form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-back">'+t('auth.back')+'</button></p>');
    submit(async()=>{
      const em=$('#au-em').value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){authErr(t('auth.eEmail'),'au-em');return}
      authBusy(true);
      try{await sendRecovery(em);openAuth('login',false,{email:em,notice:t('auth.resetSent')})}
      catch(e){authBusy(false);authErr(e.message,'au-em')}
    });
    $('#au-back').onclick=()=>openAuth('login',false,{email:$('#au-em').value.trim()});
    $('#au-em').focus();
    return;
  }
  /* ---- new password after the recovery link ---- */
  if(screen==='newpw'){
    mount(screen,arg,opts,head(t('auth.newpwTitle'),'')+
      '<form id="au-form" novalidate><div class="field"><label for="au-pw">'+t('auth.newpw')+'</label>'+
      '<div class="pwwrap"><input class="input" type="password" id="au-pw" autocomplete="new-password"><button class="pweye" id="au-eye" type="button" aria-label="'+t('lg.showPw')+'">'+IC.eye+'</button></div></div>'+
      '<div class="pwmeter" id="au-meter"></div>'+errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('c.save')+'</button></form>');
    const pw=$('#au-pw');drawPwMeter('');pw.focus();
    pw.oninput=()=>{drawPwMeter(pw.value);clearErr()};
    $('#au-eye').onclick=()=>{pw.type=pw.type==='password'?'text':'password'};
    submit(async()=>{
      if(!pwOK(pw.value)){authErr(t('auth.eWeak'),'au-pw');return}
      authBusy(true);
      try{await updatePassword(pw.value);toast(t('auth.newpwDone'));closeAuth();cloudSyncStart().then(()=>{syncPush();runDeepLink()})}
      catch(e){authBusy(false);authErr(e.message,'au-pw')}
    });
    return;
  }
  /* ---- one entry for everyone: Google or email → code (like Notion, Linear, Slack) ---- */
  if(screen==='code'){
    const email=arg;
    mount(screen,arg,opts,'<div class="mailbadge" aria-hidden="true">'+IC.mail+'</div>'+head(t('lg.codeTitle'),t('lg.codeSub',{e:'<b>'+esc(email)+'</b>'}))+
      '<form id="au-form" novalidate>'+otpBox('au-otp')+errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('lg.codeGo')+'</button></form>'+
      '<p class="authhint">'+t('lg.spam')+'</p>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-resend" disabled></button></p>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-back">'+t('lg.otherEmail')+'</button></p>');
    const go=async()=>{
      const code=$('#au-otp').value.trim();
      if(code.length!==6){authErr(t('auth.eCode'),'au-otp');return}
      authBusy(true);
      try{await verifyEmailCode(email,code);if(await mfaRequired())openAuth('mfa');else afterLogin()}
      catch(e){authBusy(false);authErr(/expired|invalid|token/i.test(e.message)?t('lg.codeBad'):e.message,'au-otp')}
    };
    codeInput(go);submit(go);
    const rb=$('#au-resend');let left=60,tm;
    const tick=()=>{if(!document.body.contains(rb)){clearInterval(tm);return}if(left>0){rb.disabled=true;rb.textContent=t('lg.resendIn',{s:left});left--}else{rb.disabled=false;rb.textContent=t('lg.resend');clearInterval(tm)}};
    tick();tm=setInterval(tick,1000);
    rb.onclick=async()=>{try{rb.disabled=true;await sendEmailCode(email,!!opts.signup);toast(t('auth.otpResent'));left=60;tick();clearInterval(tm);tm=setInterval(tick,1000)}catch(e){authErr(e.message)}};
    $('#au-back').onclick=()=>openAuth('login',!!opts.signup,{email});
    return;
  }
  if(screen==='password'){
    mount(screen,arg,opts,head(t('lg.pwTitle'),'')+
      '<form id="au-form" novalidate>'+
        '<div class="field"><label for="au-em">'+t('cloud.email')+'</label><input class="input" type="email" id="au-em" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" value="'+esc(opts.email||'')+'"></div>'+
        '<div class="field"><div class="pwlabel"><label for="au-pw">'+t('lg.pw')+'</label><button type="button" class="linkbtn" id="au-forgot">'+t('lg.forgotShort')+'</button></div>'+
          '<div class="pwwrap"><input class="input" type="password" id="au-pw" autocomplete="current-password"><button class="pweye" id="au-eye" type="button" aria-label="'+t('lg.showPw')+'">'+IC.eye+'</button></div>'+
          '<div class="capsnote" id="au-caps" hidden>'+t('lg.caps')+'</div></div>'+
        errBox+'<button class="btn primary big authgo" type="submit" id="au-go">'+t('cloud.signin')+'</button>'+
      '</form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-code">'+t('lg.useCode')+'</button></p>');
    const pw=$('#au-pw'),em=$('#au-em');
    pw.addEventListener('input',clearErr);em.addEventListener('input',clearErr);
    const caps=e=>{const c=$('#au-caps');if(c&&e.getModifierState)c.hidden=!e.getModifierState('CapsLock')};
    pw.addEventListener('keyup',caps);pw.addEventListener('keydown',caps);
    $('#au-eye').onclick=()=>{pw.type=pw.type==='password'?'text':'password';pw.focus()};
    $('#au-forgot').onclick=()=>openAuth('forgot',em.value.trim());
    $('#au-code').onclick=()=>openAuth('login',false,{email:em.value.trim()});
    $('#au-pwback')&&($('#au-pwback').onclick=()=>openAuth('login',true,{email:em.value.trim()}));
    submit(async()=>{
      const e=em.value.trim(),p=pw.value;
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)){authErr(t('auth.eEmail'),'au-em');return}
      if(!p){authErr(t('auth.ePw'),'au-pw');return}
      authBusy(true);
      try{if(await cloudSignIn(e,p))openAuth('mfa');else afterLogin()}
      catch(x){authBusy(false);authErr(x.message,/password|Passwort|credentials/i.test(x.message)?'au-pw':'au-em')}
    });
    setTimeout(()=>{(opts.email?pw:em).focus()},300);
    return;
  }
  /* sign in with an email code instead of the password */
  if(screen==='emailcode'){
    mount(screen,arg,opts,head(t('lg.codeLoginTitle'),t('lg.codeLoginSub'))+
      '<form id="au-form" novalidate><div class="field"><label for="au-em">'+t('cloud.email')+'</label><input class="input" type="email" id="au-em" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" value="'+esc(opts.email||'')+'"></div>'+errBox+
      '<button class="btn primary big authgo" type="submit" id="au-go">'+t('lg.sendCode')+'</button></form>'+
      '<p class="authswitch"><button type="button" class="linkbtn" id="au-back">'+t('auth.back')+'</button></p>');
    const em=$('#au-em');if(opts.lockEmail){em.readOnly=true;em.dataset.locked='1';em.classList.add('locked')}em.addEventListener('input',clearErr);setTimeout(()=>em.focus(),300);
    $('#au-back').onclick=()=>openAuth('login',false,{...(opts.join?{join:opts.join,lockEmail:true}:{}),email:em.value.trim()});
    submit(async()=>{const e=em.value.trim();
      if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)){authErr(t('auth.eEmail'),'au-em');return}
      authBusy(true);
      try{await sendEmailCode(e,false);openAuth('code',e,{signup:false})}
      catch(x){authBusy(false);authErr(/signup|not allowed|not found|otp_disabled|user/i.test(x.message)?t('lg.noAccount'):/rate|seconds|security/i.test(x.message)?t('lg.wait'):x.message,'au-em')}
    });
    return;
  }
  /* the familiar pair: /login (email + password) and /signup (name, email, password) */
  const signup=!!arg;
  setPath(signup?'/signup':'/login');
  const nt=opts.join?t(signup?'team.joinUp':'team.joinIn',{org:opts.join.org||'',inviter:opts.join.inviter||''}):opts.notice;
  const keepJoin=()=>opts.join?{join:opts.join,lockEmail:true}:{};
  mount(screen,arg,opts,head(t(signup?'lg.suTitle':'lg.inTitle'),signup?t('lg.suSub'):t('lg.inSub'))+
    (nt?'<div class="authnotice" role="status">'+esc(nt)+'</div>':'')+
    '<button class="btn big gbtn" type="button" id="au-g">'+GLOGO+' '+t(signup?'lg.suGoogle':'lg.inGoogle')+'</button>'+
    '<div class="authsplit"><span>'+t('cloud.or')+'</span></div>'+
    '<form id="au-form" novalidate>'+
      (signup?'<div class="field"><label for="au-name">'+t('lg.name')+'</label><input class="input" id="au-name" autocomplete="name" value="'+esc(opts.name||'')+'"></div>':'')+
      '<div class="field"><label for="au-em">'+t('cloud.email')+'</label><input class="input" type="email" id="au-em" autocomplete="email" inputmode="email" autocapitalize="off" spellcheck="false" value="'+esc(opts.email||'')+'"></div>'+
      '<div class="field"><div class="pwlabel"><label for="au-pw">'+t('lg.pw')+'</label>'+(signup?'':'<button type="button" class="linkbtn" id="au-forgot">'+t('lg.forgotShort')+'</button>')+'</div>'+
        '<div class="pwwrap"><input class="input" type="password" id="au-pw" autocomplete="'+(signup?'new-password':'current-password')+'"><button class="pweye" id="au-eye" type="button" aria-label="'+t('lg.showPw')+'">'+IC.eye+'</button></div>'+
        (signup?'<p class="pwhint" id="au-pwhint">'+t('lg.pwRule')+'</p>':'')+
        '<div class="capsnote" id="au-caps" hidden>'+t('lg.caps')+'</div></div>'+
      errBox+
      '<button class="btn primary big authgo" type="submit" id="au-go">'+t(signup?'lg.suGo':'cloud.signin')+'</button>'+
    '</form>'+
    (signup?'':'<p class="authswitch"><button type="button" class="linkbtn" id="au-codel">'+t('lg.useCode')+'</button></p>')+
    '<div class="authalt">'+t(signup?'lg.have':'lg.new')+' <button type="button" class="linkbtn strong" id="au-sw">'+t(signup?'lg.toIn':'lg.toUp')+'</button></div>'+
    (signup?'<p class="authlegal">'+t('lg.legalSignup',{terms:ext(LEGAL.terms,t('lg.terms')),privacy:ext(LEGAL.privacy,t('lg.privacy'))})+'</p>':''));
  const em=$('#au-em'),pw=$('#au-pw'),nm=$('#au-name'),hint=$('#au-pwhint');
  [em,pw,nm].forEach(x=>x&&x.addEventListener('input',clearErr));
  if(hint)pw.addEventListener('input',()=>hint.classList.toggle('ok',pw.value.length>=10));
  const caps=e=>{const c=$('#au-caps');if(c&&e.getModifierState)c.hidden=!e.getModifierState('CapsLock')};
  pw.addEventListener('keyup',caps);pw.addEventListener('keydown',caps);
  $('#au-eye').onclick=()=>{pw.type=pw.type==='password'?'text':'password';pw.focus()};
  $('#au-g').onclick=()=>{
    if(location.protocol==='file:'){authErr(t('cloud.googleHosted'));return}
    $('#au-g').classList.add('busy');location.href=googleAuthUrl();
  };
  if($('#au-forgot'))$('#au-forgot').onclick=()=>openAuth('forgot',em.value.trim());
  if(opts.lockEmail){em.readOnly=true;em.dataset.locked='1';em.classList.add('locked')}
  if($('#au-codel'))$('#au-codel').onclick=()=>openAuth('emailcode',null,{...keepJoin(),email:em.value.trim()});
  $('#au-sw').onclick=()=>openAuth('login',!signup,{...keepJoin(),email:em.value.trim()});
  submit(async()=>{
    const e=em.value.trim(),p=pw.value,n=nm?nm.value.trim():'';
    if(signup&&!n){authErr(t('lg.eName'),'au-name');return}
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e)){authErr(t('auth.eEmail'),'au-em');return}
    if(!p){authErr(t('auth.ePw'),'au-pw');return}
    if(signup&&p.length<10){authErr(t('lg.pwRule'),'au-pw');return}
    authBusy(true);
    try{
      if(signup){const res=await cloudSignUp(e,p,n);if(res==='otp'){openAuth('otp',e);return}afterLogin()}
      else{if(await cloudSignIn(e,p))openAuth('mfa');else afterLogin()}
    }catch(x){
      authBusy(false);const m=String(x.message||'');
      if(/already registered|already exists/i.test(m)){openAuth('login',false,{...keepJoin(),email:e,notice:opts.join?undefined:t('lg.exists')});return}
      if(/not confirmed/i.test(m)){try{await resendOtp(e,'signup')}catch(_){}openAuth('otp',e);return}
      if(/invalid login|credentials|invalid_grant/i.test(m)){authErr(t('lg.badLogin'),'au-pw');return}
      authErr(/rate|seconds|security/i.test(m)?t('lg.wait'):m,/password|Passwort/i.test(m)?'au-pw':'au-em');
    }
  });
  if(!opts.email)setTimeout(()=>{if(window.matchMedia&&matchMedia('(min-width:761px)').matches)(nm||em).focus()},350);
}
/* keep the address bar honest: /login, /signup, and back to / once signed in */
function setPath(p){try{if(location.pathname!==p)history.replaceState(null,'',p+location.hash)}catch(e){}}
export function goOffline(){try{localStorage.setItem('plume.mode','local')}catch(e){}closeAuth();updateAccountUI();if(RT.v==='settings')render()}
/* Signed out with a configured backend → always the sign-in page (no more "use without account"). */
export async function maybeShowAuth(opts){
  if(!cloudOn()||loggedIn())return;
  try{localStorage.removeItem('plume.mode')}catch(e){}
  let signup=false;
  try{const q=new URLSearchParams(location.search);signup=q.has('signup')||location.pathname.replace(/\/$/,'')==='/signup'}catch(e){}
  if(pendingJoin()){
    const j=await Promise.race([joinNotice().catch(()=>null),new Promise(r=>setTimeout(()=>r(null),5000))]);
    /* a known address signs in, a new one creates its account; either way for the invited address only */
    if(j&&j.join){openAuth('login',j.hasAccount!==true,{...(opts||{}),email:j.email,lockEmail:true,join:j});return}
    if(j&&j.notice){openAuth('login',false,{...(opts||{}),email:j.email||'',notice:j.notice});return}
  }
  openAuth('login',signup,opts||{});
}
